/**
 * F-0160 §11 (I-0638): a new deployment's first administrator comes from a one-time setup token.
 *
 * The one place the operator's command is spelled, so the server log, the setup screen and the
 * self-hosting guide cannot drift apart. The API image runs `node backend/dist/src/main.js` from
 * `/app/code` (`Dockerfile.stable`), and the command sits beside it.
 */
export const DEPLOYMENT_SETUP_COMMAND = 'node backend/dist/src/setup/mint-setup-token.js';

/** How long a minted setup token stays usable, in minutes. */
export const DEPLOYMENT_SETUP_TOKEN_MINUTES = 30;

/**
 * F-0160 §11.5 (I-0638): the browser door. When the API starts and finds no administrator, it lets
 * a person create one in the browser for this many minutes. `0` turns the browser door off.
 */
export const FIRST_RUN_WINDOW_VARIABLE = 'FEATIT_FIRST_RUN_WINDOW_MINUTES';
export const FIRST_RUN_WINDOW_DEFAULT_MINUTES = 15;

/** How the self-hosting guide restarts the API, which reopens the browser door. */
export const DEPLOYMENT_RESTART_COMMAND =
  'docker compose --env-file .env.selfhost -f docker-compose.selfhost.yml restart backend';

/**
 * What `featit bootstrap` runs by default to prove it is on the host: the mint command, inside the
 * API container of the self-hosting compose file, asking for JSON so the token is read rather than
 * shown.
 */
export const DEPLOYMENT_BOOTSTRAP_MINT_COMMAND = `docker compose --env-file .env.selfhost -f docker-compose.selfhost.yml exec -T backend ${DEPLOYMENT_SETUP_COMMAND} --json`;

/** The agent door's claim link: where the named person sets a password or passkey. */
export const ACCOUNT_CLAIM_PATH = '/claim';

/** How long a claim link works, in minutes. Its administrator's agent can issue a new one. */
export const ACCOUNT_CLAIM_TOKEN_MINUTES = 60;

/** What `GET /auth/setup` answers. A fact about the deployment, the same for every visitor. */
export interface IDeploymentSetupStatus {
  /** No active account administers this deployment. */
  readonly required: boolean;
  readonly firstRun: {
    /** A person may create the administrator in the browser right now. */
    readonly open: boolean;
    /** When the browser door closes, while it is open. */
    readonly closesAt: string | null;
    /** The configured length of the window. `0` means the browser door is off. */
    readonly minutes: number;
  };
}

/** The refusal code the browser door answers once its window has closed. */
export const FIRST_RUN_CLOSED_CODE = 'first-run-closed';
